import { createContext } from 'react';

import { LoginMethodType } from 'Lib/constant';
import { IFeaturesContext } from 'SharedComponents/hooks/useFeatures';

const FeaturesContext = createContext<IFeaturesContext>({
    authentication: {
        Type: 'Keycloak',
        SSO: false,
        LoginMethod: LoginMethodType.HOSTED_KEYCLOAK
    },
    isSSOEnabled: false
});

export { FeaturesContext };